<template>
    <div class="relative">
        <div
            @click="toggle"
            class="flex items-center justify-center h-10 gap-0.5 cursor-pointer languageBox"
        >
            <span class="flex text-xs font-semibold lg:text-sm text-theme-secondary">{{
                currentLanguage.toUpperCase()
            }}</span>
            <Icon type="arrow-dropdown" class="text-theme-disabled" :class="menuopen ? 'rotate-180' : ''" :width="10" :height="6" />
        </div>
        <!-- Language Switcher -->
        <div
            class="absolute bg-theme-paper w-max rounded-lg min-w-44 overflow-hidden top-[calc(100%+16px)] right-full z-30 shadow-dropdown translate-x-1/4 group-[&amp;.active]/dropdown:block"
            v-if="menuopen"
        >
            <ul class="flex flex-col gap-1">
                <li
                    v-for="(lg, key) in langs"
                    :key="key"
                    class="flex items-center justify-between gap-2 p-4 overflow-hidden cursor-pointer group/li hover:bg-theme-neutral"
                    :class="{ 'bg-theme-neutral': key === currentLanguage }"
                    @click="handleChangeLanguage(key)"
                >
                    <div class="max-w-7 shrink-0">
                        <img :src="lg.flag" :alt="key" />
                    </div>
                    <h6
                        class="text-xs font-bold lg:text-sm group-hover/li:text-theme-primary"
                        :class="key === currentLanguage ? 'text-theme-primary' : 'text-theme-disabled'"
                    >
                        {{ key.toUpperCase() }}
                    </h6>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import { useI18n } from 'vue-i18n';
import Icon from '@/Icons/OptimizedIcons.vue';
export default {
  components: {
    Icon,
  },
  data() {
    return {
		auth: this.$page.props.auth,
      langs: {
        en: {
          name: 'English',
          flag: '/images/flag.png',
        },
        fr: {
          name: 'French',
          flag: '/images/french.png',
        },
        de: {
          name: 'German',
          flag: '/images/german.png',
        },
        it: {
          name: 'Italian',
          flag: '/images/ic-it.png',
        },
        es: {
          name: 'Spanish',
          flag: '/images/ic-es.png',
        },
        pt: {
          name: 'Portuguese',
          flag: '/images/ic-pt.png',
        },
        el: {
          name: 'Greek',
          flag: '/images/ic-gr.png',
        },
        nl: {
          name: 'Dutch',
          flag: '/images/ic-nl.png',
        },
        ro: {
          name: 'Romanian',
          flag: '/images/ic-ro.png',
        },
        pl: {
          name: 'Polish',
          flag: '/images/ic-pl.png',
        },
      },
      menuopen: false,
    };
  },

  setup() {
    const { t, locale } = useI18n();
    const changeLanguage = async function (lang) {
      try {
        await axios.post('/lang', { locale: lang });

                this.menuopen = false;
                locale.value = lang;
                localStorage.setItem("locale", lang);
                location.reload();
            } catch (error) {
                console.error(error);
            }
        };
        return {
            t,
            currentLanguage: [
                "en",
                "de",
                "fr",
                "it",
                "es",
                "pt",
                "el",
                "nl",
                "ro",
                "pl",
            ].includes(locale.value)
                ? locale
                : "en",
            changeLanguage,
        };
    },
    methods: {
        toggle(event) {
            this.menuopen = !this.menuopen;
        },
        handleChangeLanguage(lang) {
            this.menuopen = false;
            this.changeLanguage(lang);
        },
    },
};
</script>
